import List from 'src/storage/list';
import moment from 'moment';
import adminModel from 'src/pages/admin/main/model';
import { isAdminPage } from 'src/helpers';
import constants from 'src/constants';
const defaultCurrency = constants.general.defaultCurrency;

class SettingEarningModel extends List {
  id = 'SettingEarningModel';
  defaultState = () => ({
    current: 'recent',
    pageIndex: 0,
    sortBy: {
      key: 'created',
      desc: true
    },
    endDate: moment(),
    totalEarnings: 0,
    lastMonthEarnings: 0
  });
  refreshOnInit = false;
  refreshOnSubscribe = true;
  apiConfig = {
    refresh: {
      url: 'doctorStats/list',
      validation: {
        skip: 'skip',
        limit: 'limit',
        currency: 'currency'
      },
      cancellable: true
    },
    list: {
      url: 'doctorStats/list',
      validation: {
        skip: 'skip',
        limit: 'limit',
        currency: 'currency'
      },
      cancellable: true
    },
    total: {
      url: 'doctorStats/total',
      validation: { currency: 'currency' },
      cancellable: true
    }
  };

  _events = {
    change_currency: 'handleChangeCurrency',
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  listParams() {
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      dateType: this.state.type || 'all',
      period: this.state.period || 'day',
      currency: this.getCurrency()
    };
    if (isAdminPage()) req.admin = true;
    let startDate = this.input('startDate');
    if (startDate) {
      req.startDate = parseInt(startDate.clone().utc(true).valueOf());
    }
    let endDate = this.input('endDate');
    if (endDate) {
      req.endDate = parseInt(endDate.clone().utc(true).valueOf());
    }
    return req;
  }

  changePeriod = (val) => {
    this.setState({ period: val });
    this.refresh();
  };

  loadTotal = () => {
    let req = { currency: this.getCurrency() };
    if (isAdminPage()) req.admin = true;
    this.api('total', req, (err, res) => {
      this.setState({ totalEarnings: res?.total || 0, lastMonthEarnings: res?.lastMonth || 0 });
    });
  };

  getCurrency = () => {
    return isAdminPage()
      ? adminModel.getCurrency()
      : this.input('currency') || this.getUser()?.currency || defaultCurrency;
  };

  handleChangeCurrency = () => {
    this.refresh();
    this.loadTotal();
  };
}

const model = new SettingEarningModel();
export default model;
